import styled from '@emotion/styled';
import { FC, ReactNode } from 'react';

import { IThemeProps } from '@/styles/themes/types';

export const TabsContainer = styled('div')<IThemeProps>`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  overflow-x: auto;
  ${({ theme }) => theme.legacy.scrollbarXStyle()};
`;

export interface IHorizontalTabsProps {
  tabs?: Array<any>;
  selected?: any;
  children: (tab: any, selected: boolean, onClick: (tab: string) => void) => ReactNode;
  onChange?(tabName: any): void;
}

export const HorizontalTabs: FC<IHorizontalTabsProps> = ({ tabs, selected, children, onChange, ...restProps }) => {
  function handleClick(tab) {
    if (selected === tab) {
      return;
    }

    onChange(tab);
  }

  return (
    <TabsContainer {...restProps}>
      {tabs && tabs.map((tab) => children(tab, selected === tab, handleClick))}
    </TabsContainer>
  );
};
